const baseHtmlClass = `body_liner`;
const prohibitClassModifier = `noScroll`;

export function prohibitBodyScroll() {
    const element = getBodyLinerElement();
    if (!element) return;


    storeScrollOffset(element);
    element.classList.add(`${ baseHtmlClass }--${ prohibitClassModifier }`);
}

export function allowBodyScroll() {
    const element = getBodyLinerElement();
    if (!element) return;

    const scrollOffset = retrieveScrollOffset(element);
    setScrollOffset(scrollOffset);
    element.classList.remove(`${ baseHtmlClass }--${ prohibitClassModifier }`);

}

function getBodyLinerElement() {
    return document.body.getElementsByClassName(baseHtmlClass)[0];
}

function getScrollOffset() {
    return window.pageYOffset;
}

function setScrollOffset(offset) {
    return window.pageYOffset = offset;
}

function storeScrollOffset(element) {
    element.dataset['scrollOffset'] = getScrollOffset();
}

function retrieveScrollOffset(element) {
    return element.dataset['scrollOffset'];
}
